import moment from 'moment'
import numeral from 'numeral'

const limitHour = moment({ hour: 16, minute: 5 })
const minDate = moment() < limitHour ? moment({ hour: 0 }) : moment({ hour: 0 }).add(1, 'day')
const currentDate = new Date();

export const generalData = {
  cliente: {
    name: 'cliente',
    label: 'Cliente',
    valueProperty: 'id',
    valueLabel: 'nombreORazonSocial',
    validation: 'required',
    trigger: 'getClient',
  },
  id: {
    name: 'id',
    label: 'Id',
    disabled: true,
  },
  estatusOrden: {
    value: '',
    name: 'estatusOrden',
    label: 'Estatus Orden',
    valueProperty: 'id',
    valueLabel: 'estatus',
    disabled: true,
  },
  fechaProgramacionEmisionFactura: {
    name: 'fechaProgramacionEmisionFactura',
    value: minDate.toDate(),
    minDate: minDate.toDate(),
    label: 'Fecha emisión Factura',
    validation: 'required',
    format: val => console.log(val),
    dataMarshaller: (value) => moment(value).format('YYYY-MM-DD'),
    dataUnmarshaller: val => moment(val).toDate(),
  },
  tipoDePersona: {
    value: '',
    trigger: 'onChangeTipoPersona',
    transform: 'stringToNumber',
    name: 'tipoPersona',
    label: 'Tipo de persona',
    disabled: true,
  },
  regimenFiscalReceptor: {
    value: '',
    name: 'regimenFiscalReceptor',
    label: 'Régimen Fiscal del Cliente',
    valueProperty: 'id',
    valueLabel: 'descripcion',
    disabled: true,
    validation: 'required',
  },
  rfc: {
    value: '',
    name: 'rfc',
    label: 'RFC',
    disabled: true,
    trigger: 'onChangeRfc',
  },
  correoElectronico: {
    value: '',
    name: 'correoElectronico',
    label: 'Correo Electrónico',
    disabled: true,
  },
  nombreORazonSocial: {
    value: '',
    name: 'nombreRazonSocial',
    label: 'Nombre o Razón Social',
    disabled: true,
    validation: 'isValidName',
  },
  numRegIdTrib: {
    value: '',
    name: 'numRegIdTrib',
    label: 'Tax Id Number (Sólo para extranjeros)',
    disabled: true,
  },
  formaPago: {
    name: 'formaPago',
    label: 'Método de Pago',
    value: '',
    validation: 'required',
    options: [
      {
        label: 'Pago en Parcialidades',
        value: 'Pago en Parcialidades'
      },
      {
        label: 'Pago en Una sola Exhibición',
        value: 'Pago en Una sola Exhibición'
      },
    ],
    trigger: 'onChangePaymentMethod',
  },
  metodoPago: {
    name: 'metodoPago',
    label: 'Forma de Pago',
    value: '',
    valueProperty: 'id',
    valueLabel: 'metodoPago',
    validation: 'required',
  },
  ultimos4Digitos: {
    value: '',
    name: 'ultimos4Digitos',
    label: 'Últimos 4 dígitos Cuenta Bancaria',
    pattern: 'number',
  },
  UsoCFDISAT: {
    value: '',
    name: 'UsoCFDISAT',
    label: 'Uso CFDI SAT',
    validation: 'required',
    valueLabel: 'descripcion',
    valueProperty: 'id',
  },
  divisaMoneda: {
    value: '',
    name: 'divisaMoneda',
    label: 'Divisa Moneda',
    validation: 'required',
    valueLabel: 'codigo',
    valueProperty: 'codigo',
    trigger: 'onChangeCurrency',
  },
  tipoCambio: {
    value: '',
    name: 'tipoCambio',
    label: 'Tipo de Cambio',
  },
  cuentaCobranza: {
    value: '',
    name: 'cuentaCobranza',
    label: 'Cuenta para Cobranza',
    validation: 'required',
    options: [
      {
        label: 'MXN',
        value: 'MXN'
      },
      {
        label: 'USD',
        value: 'USD'
      }
    ]
  },
  tipoRelacion: {
    value: '',
    name: 'tipoRelacion',
    label: 'Tipo de Relación',
    valueProperty: 'id',
    valueLabel: 'Descripcion',
    trigger: 'onChangeRelationshipType',
  },
  uuidRelacionado: {
    value: '',
    name: 'uuidRelacionado',
    label: 'UUID Relacionado',
    valueProperty: 'uuid',
    valueLabel: 'label',
    validation: 'requiredIf:tipoRelacion',
  },
  ventaGlobal: {
    name: 'ventaGlobal',
    label: 'Venta global',
    value: '',
    dataUnmarshaller: val => val === '1' ? true : false,
  },
  periodicidad: {
    name: 'periodicidad',
    label: 'Periodicidad',
    value: '',
    valueProperty: 'id',
    valueLabel: 'descripcion',
  },
  meses: {
    name: 'meses',
    label: 'Meses',
    value: '',
    valueProperty: 'id',
    valueLabel: 'descripcion',
  },
  anio: {
    name: 'anio',
    label: 'Año',
    value: currentDate.getFullYear(),
    valueProperty: 'id',
    valueLabel: 'id',
  },
  cuentaClabeSTPAsignada: {
    name: 'cuentaClabeSTPAsignada',
    value: 'cuentaClabeSTPAsignada',
  },
  exportacion: {
    value: '1',
    name: 'exportacion',
    label: 'Exportación',
    valueProperty: 'id',
    valueLabel: 'descripcion',
    validation: 'required',
  },

}
export const incomeInvoiceList =
  [
    {
      title: 'ID',
      datakey: 'id',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Estatus Orden',
      datakey: 'estatusTexto',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Nombre o Razón Social',
      datakey: 'nombreORazonSocial',
      sortable: true,
      width: '40%',
    },
    {
      title: 'Total',
      datakey: 'Total',
      format: '$ 0,0.00',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '10%',
    },
  ]

export const addressData = {
  direccion: {
    value: '',
    transform: 'stringToBool',
    trigger: 'onChangeDireccion',
    name: 'direccion',
    label: 'Dirección',
    disabled: true,
  },
  pais: {
    name: 'pais',
    value: '',
    validation: 'requiredIf:direccion',
    label: 'País',
    disabled: true
  },
  codigoPostal: {
    value: '',
    trigger: 'onChangeCp',
    pattern: 'number',
    name: 'codigoPostal',
    label: 'Código postal',
    disabled: true,
    validation: 'required|greaterThan:0',
  },
  entidadFederativa: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'entidadFederativa',
    label: 'Entidad Federativa/Estado/Provincia',
    disabled: true,
  },
  municipio: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'municipio',
    label: 'Municipio',
    disabled: true,
  },
  colonia: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'colonia',
    label: 'Colonia',
    disabled: true,
  },
  calle: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'calle',
    label: 'Calle',
    disabled: true,
  },
  exterior: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'exterior',
    label: 'Exterior',
    disabled: true,
  },
  interior: {
    value: '',
    name: 'interior',
    label: 'Interior',
    disabled: true,
  },
}
export const conceptData = {
  concepto: {
    name: 'concepto',
    label: 'Concepto',
    value: '',
    validation: 'required',
  },
  unidad: {
    name: 'unidad',
    label: 'Unidad',
    value: '',
    validation: 'required',
    placeholder: 'Buscar unidad...',
  },
  unitario: {
    name: 'unitario',
    label: 'Importe Unitario',
    value: '',
    validation: 'required',
    pattern: 'number',
    trigger: 'updateCalculations',
  },
  unitarioDescuento: {
    name: 'unitarioDescuento',
    label: 'Descuento Unitario',
    value: '',
    validation: 'greaterOrEqualThan:0|lessThanField:unitario',
    pattern: 'number',
    trigger: 'updateCalculations',
  },
  importeDescuento: {
    name: 'importeDescuento',
    label: 'Importe Descuento',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  total: {
    name: 'total',
    label: 'Total',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  iva: {
    name: 'iva',
    label: 'IVA',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  retenciones: {
    name: 'retenciones',
    value: false,
    label: 'Retenciones de Impuestos',
  },
  tasaRetISR: {
    name: 'tasaRetISR',
    value: '',
    label: 'Tasa Retención ISR',
    trigger: 'updateCalculations',
    pattern: 'number',
  },
  retISR: {
    name: 'retISR',
    value: '',
    pattern: 'number',
    label: 'Retención ISR',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  tasaRetIEPS: {
    name: 'tasaRetIEPS',
    value: '',
    label: 'Tasa Retención IEPS',
    trigger: 'updateCalculations',
    pattern: 'number',
  },
  retIEPS: {
    name: 'retIEPS',
    value: '',
    pattern: 'number',
    label: 'Retención IEPS',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  tasaRetIVA: {
    name: 'tasaRetIVA',
    value: '',
    label: 'Tasa Retención IVA',
    trigger: 'updateCalculations',
    pattern: 'number',
  },
  retIVA: {
    name: 'retIVA',
    value: '',
    pattern: 'number',
    label: 'Retención IVA',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  cantidad: {
    name: 'cantidad',
    label: 'Cantidad',
    pattern: 'number',
    value: '',
    validation: 'required',
    trigger: 'updateCalculations',
  },
  tasaIeps: {
    name: 'tasaIeps',
    label: 'Tasa IEPS',
    value: '',
    // validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
    trigger: 'updateCalculations',
  },
  tasaIva: {
    name: 'tasaIva',
    label: 'Tasa IVA',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
    trigger: 'updateCalculations',
  },
  tipoCalculo: {
    name: 'tipoCalculo',
    label: 'Tipo de Cálculo',
    value: 1,
    validation: 'required',
    transform: 'stringToNumber',
    trigger: 'updateCalculations',
    options: [
      {
        value: 1,
        label: 'El IVA Grava sobre Subtotal'
      },
      {
        value: 2,
        label: 'El IVA Grava sobre Subtotal + IEPS'
      },
    ],
  },
  claveProductoServicioSAT: {
    name: 'claveProductoServicioSAT',
    label: 'Clave Producto Servicio',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'tipo',
  },
  objetoImp: {
    name: 'objetoImp',
    label: 'Objeto impuesto',
    value: '2',
    valueProperty: 'id',
    valueLabel: 'descripcion',
    validation: 'required',
  },
  identificador: {
    name: 'identificador',
    label: 'Identificador',
    maxLength: 11,
    value: '',
  },
  pedimentoAduana: {
    name: 'pedimentoAduana',
    label: 'Número de Pedimento Aduana',
    maxLength: 21,
    value: '',
    validation: 'aduana',
  },
  tasaIVA: {
    same: 'tasaIva',
  },
  tasaIEPS: {
    same: 'tasaIeps',
  },
  query: {
    name: 'query',
    label: 'Buscar producto o servicio por concepto o identificador',
    value: '',
  },
  idProductoServicio: {
    name: 'idProductoServicio',
    value: '',
  },
  banderaEscuela: {
    name: 'banderaEscuela',
    value: false,
    label: 'Complemento Escuela',
  },
  nombreAlumno: {
    name: 'nombreAlumno',
    value: '',
    label: 'Nombre del Alumno',
  },
  curp: {
    name: 'curp',
    value: '',
    label: 'CURP Alumno',
  },
  nivelEducativo: {
    name: 'nivelEducativo',
    value: '',
    label: 'Nivel Educativo',
  },
  autRVOE: {
    name: 'autRVOE',
    value: '',
    label: 'RVOE',
  },
  studentFinder: {
    name: 'studentFinder',
    value: '',
    label: 'Buscar Nombre del Alumno',
  }
}
export const conceptsCol = [
  {
    title: 'Concepto',
    datakey: 'concepto',
  },
  {
    title: 'Subtotal',
    datakey: 'subtotal',
    format: '$ 0,0.00',
  },
  {
    title: 'IVA',
    datakey: 'iva',
    format: '$ 0,0.00',
  },
  {
    title: 'Total',
    datakey: 'total',
    format: '$ 0,0.00',
  },
  {
    title: 'Acciones',
    custom: 'acciones',
  }
]
export const paymentCol = [
  {
    title: 'Id',
    datakey: 'id',
  },
  {
    title: 'Fecha de transacción',
    datakey: 'fechaTransaccion',
    format: (value) => moment(value).format('DD/MM/YYYY')
  },
  {
    title: 'Estatus',
    datakey: 'estatusTexto',
  },
  {
    title: 'Abono',
    datakey: 'abonos',
    format: '$ 0,0.00',
  },
  {
    title: 'Moneda',
    datakey: 'monedaDivisa',
  },
  {
    title: 'Referencia del banco',
    datakey: 'referenciaBanco',
  },
]
export const complementaryPaymentCol = [
  {
    title: 'Fecha Uiid',
    datakey: 'FechaUUID',
    format: (value) => moment(value).format('DD/MM/YYYY'),
  },
  {
    title: 'Uuid',
    datakey: 'uuid',
  },
  {
    title: 'Serie & Folio',
    datakey: 'serieFolio',
  },
  {
    title: 'Importe Pagado',
    datakey: 'impPagado',
    format: '$ 0,0.00',
  },
  {
    title: 'Forma de Pago',
    datakey: 'formaDePagoTxt',
  },
]

export const creditNotesCol = [
  {
    title: 'Id',
    datakey: 'idCancelacion',
    width: '5%',
  },
  {
    title: 'Fecha petición',
    datakey: 'fecha',
    format: (value) => moment(value).format('DD/MM/YYYY'),
    width: '10%',
  },
  {
    title: 'Petición',
    datakey: 'accionTomar',
    width: '20%'
  },
  {
    title: 'Estatus',
    datakey: 'estatus',
    width: '8%',
  },
]

export const totals = {
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  totalDescuentos: {
    name: 'totalDescuentos',
    label: 'Descuentos',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  iva: {
    name: 'iva',
    label: 'IVA',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  totalRetenciones: {
    name: 'totalRetenciones',
    label: 'Retenciones',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoCobrado: {
    name: 'montoCobrado',
    label: 'Monto Cobrado',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPorCobrar: {
    name: 'montoPorCobrar',
    label: 'Monto Por Cobrar',
    value: 0,
    format: (value) => numeral(Math.round(+value * 100) / 100).format('$ 0,0.00'),
    align: 'right',
  },
  numeroFactura: {
    name: 'numeroFactura',
    label: 'Numero de factura',
  },
  uuid: {
    name: 'uuid',
    label: 'UUID',
    disabled: true,
  },
  total: {
    name: 'total',
    label: 'Total',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  descripcion_orden: {
    name: 'descripcion_orden',
    label: 'Descripción Orden',
    value: '',
  },
}